import classNames from 'classnames';
import type { ReactNode } from 'react';

import './TagWithIcon.scss';

type TagWithIconProps = {
  text: ReactNode;
  icon?: ReactNode;
  type: 'success' | 'default' | 'error' | 'warning';
};

export const TagWithIcon = ({ text, icon, type }: TagWithIconProps) => {
  return (
    <div className={classNames(['tag-with-icon', type])}>
      {icon && <div className="icon">{icon}</div>}
      <div className="text">{text}</div>
    </div>
  );
};
